import { GlassGuideSearchVehicle } from '@features/opportunities/models/vehicle';

const GLASS_GUIDE_VEHICLES: GlassGuideSearchVehicle[] = [
  {
    CODE: 'TKLU25',
    NVIC_KEY: 'TKLU25',
    NVIC: 'TKLU25',
    YEAR: '2025',
    MTH: '01',
    MAKE: 'TOYOTA',
    FAMILY: 'KLUGER',
    VARIANT: 'GX',
    SERIES: 'GSU70R',
    STYLE: 'Wagon',
    DRIVE: 'AWD',
    ENGINE: '3.5L',
    VALVE: 'DOHC',
    NO_OF_VALVES: '24',
    CC: '3456',
    SIZE: '3.5',
    TRANSMISSION: 'Automatic',
    CYL: '6',
    WIDTH: '1930',
    NEW_PR: '72000',
    ABOVE_AVERAGE_PR: '70000',
    AVERAGE_PR: '67000',
    BELOW_AVERAGE_PRICE: '62000'
  },
  {
    CODE: 'KSTG24',
    NVIC_KEY: 'KSTG24',
    NVIC: 'OBT524',
    YEAR: '2024',
    MTH: '01',
    MAKE: 'KIA',
    FAMILY: 'STINGER',
    VARIANT: 'GT',
    SERIES: 'CK',
    STYLE: 'Sedan',
    DRIVE: 'RWD',
    ENGINE: '3.3L',
    VALVE: 'DOHC',
    NO_OF_VALVES: '24',
    CC: '3342',
    SIZE: '3.3',
    TRANSMISSION: 'Automatic',
    CYL: '6',
    WIDTH: '1870',
    NEW_PR: '62000',
    ABOVE_AVERAGE_PR: '50600',
    AVERAGE_PR: '44000',
    BELOW_AVERAGE_PRICE: '37200'
  },
  {
    CODE: 'TCAM23',
    NVIC_KEY: 'TCAM23',
    NVIC: 'TCAM01',
    YEAR: '2023',
    MTH: '06',
    MAKE: 'TOYOTA',
    FAMILY: 'CAMRY',
    VARIANT: 'SL',
    SERIES: 'AXVH70',
    STYLE: 'Sedan',
    DRIVE: 'FWD',
    ENGINE: '2.5L',
    VALVE: 'DOHC',
    NO_OF_VALVES: '16',
    CC: '2487',
    SIZE: '2.5',
    TRANSMISSION: 'Automatic',
    CYL: '4',
    WIDTH: '1840',
    NEW_PR: '42000',
    ABOVE_AVERAGE_PR: '38000',
    AVERAGE_PR: '35000',
    BELOW_AVERAGE_PRICE: '31000'
  }
];

function searchTerm(body: unknown): string {
  if (body == null || typeof body !== 'object') {
    return '';
  }
  const search = (body as { search?: unknown }).search;
  return typeof search === 'string' ? search.trim().toLowerCase() : '';
}

function matchingVehicles(body: unknown): GlassGuideSearchVehicle[] {
  const query = searchTerm(body);
  if (!query) {
    return GLASS_GUIDE_VEHICLES;
  }
  const matches = GLASS_GUIDE_VEHICLES.filter((vehicle) =>
    [vehicle.YEAR, vehicle.MAKE, vehicle.FAMILY, vehicle.VARIANT, vehicle.NVIC]
      .join(' ')
      .toLowerCase()
      .includes(query)
  );
  return matches.length > 0 ? matches : GLASS_GUIDE_VEHICLES;
}

export function glassGuideSimpleSearchResponse(body: unknown) {
  const value = matchingVehicles(body).map((vehicle) => ({
    YEAR: vehicle.YEAR,
    MAKE: vehicle.MAKE,
    FAMILY: vehicle.FAMILY
  }));
  return {
    '@data.context': '',
    '@data.count': value.length,
    value
  };
}

export function glassGuideSearchResponse(body: unknown) {
  const value = matchingVehicles(body);
  return {
    '@data.context': '',
    '@data.count': value.length,
    value
  };
}
